<template>
    <v-layout justify-center>
        <v-responsive max-width="1080px" width="100%" class="px-0 px-md-4 px-xl-8">
            <v-row class="mt-0 mt-md-8" justify="center" align="center">
                <v-col cols="auto" class="pt-0 pb-0 headline text-start">
                    <v-layout align-center>
                        정산관리
                        <v-icon @click="$refs['overlay-setting'].open()" color="secondary" class="ml-2"> {{ mdiCog }} </v-icon>
                        <overlay-setting ref="overlay-setting" />
                    </v-layout>
                </v-col>
                <v-spacer />
                <!-- <v-col cols="auto" class="pt-0 pb-0">
                    <v-btn class="ma-2" color="secondary" rounded @click="showSearch = !showSearch"> <v-icon small class="mr-2">mdi-filter-variant</v-icon>검색필터</v-btn>
                </v-col> -->
            </v-row>

            <!-- <v-expand-transition>
                <v-card v-show="showSearch" class="elevation-1 mx-auto">
                    <v-card-title class="subtitle-2 font-weight-bold">검색필터</v-card-title>
                    <v-card-text class="py-0">
                        <v-row class="mt-4" align="center">
                            <v-col cols="12" sm="6" class="py-0">
                                <v-date-field
                                    v-model="filter.startDate"
                                    label="정산일자 From"
                                    placeholder=" "
                                    dense
                                    hide-details
                                    @input="filter.createdAt[0] = filter.startDate ? new Date(`${filter.startDate} 00:00:00.000`).getTime() : null"
                                />
                            </v-col>
                            <v-col cols="12" sm="6" class="py-0">
                                <v-date-field
                                    v-model="filter.endDate"
                                    label="정산일자 To"
                                    placeholder=" "
                                    dense
                                    hide-details
                                    @input="filter.createdAt[1] = filter.endDate ? new Date(`${filter.endDate} 23:59:59.999`).getTime() : null"
                                />
                            </v-col>
                        </v-row>
                        <v-row class="mt-6">
                            <v-col cols="12" sm="6" class="py-0">
                                <v-select v-model="filter.searchKey" :items="searchKeys" item-text="text" item-value="value" dense hide-details label="상세조건" placeholder=" " />
                            </v-col>
                            <v-col cols="12" sm="6" class="py-0">
                                <v-text-field v-model="filter.searchValue" dense hide-details :disabled="!filter.searchKey" />
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer />
                        <v-btn color="primary" rounded text @click="search"> <v-icon small class="mt-1 mr-2">mdi-magnify</v-icon>검색</v-btn>
                    </v-card-actions>
                </v-card>
            </v-expand-transition> -->

            <v-row class="mt-4">
                <v-col cols="12" sm="6" md="3" class="py-0">
                    <v-card>
                        <v-card-text>
                            <v-row align="center">
                                <v-col cols="auto" class="py-0 pr-0"> <v-icon class="mr-2">mdi-check-all</v-icon>전체</v-col>
                                <v-spacer />
                                <v-col cols="auto" class="py-0 pl-0">
                                    <span class="font-weight-bold">
                                        <button
                                            class="primary--text"
                                            @click="
                                                filter.isDone = null;
                                                search();
                                            "
                                        >
                                            {{ dashboard.totalCount }}
                                        </button>
                                    </span>
                                    건
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col cols="12" sm="6" md="3" class="py-0">
                    <v-card>
                        <v-card-text>
                            <v-row align="center">
                                <v-col cols="auto" class="py-0 pr-0"> <v-icon class="mr-2">mdi-check</v-icon>정산대기</v-col>
                                <v-spacer />
                                <v-col cols="auto" class="py-0 pl-0">
                                    <span class="font-weight-bold">
                                        <button
                                            class="primary--text"
                                            @click="
                                                filter.isDone = false;
                                                search();
                                            "
                                        >
                                            {{ dashboard.totalCount - dashboard.isDone || 0 }}
                                        </button>
                                    </span>
                                    건
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col cols="12" sm="6" md="3" class="py-0">
                    <v-card>
                        <v-card-text>
                            <v-row align="center">
                                <v-col cols="auto" class="py-0 pr-0"> <v-icon class="mr-2">mdi-check-outline</v-icon>정산완료</v-col>
                                <v-spacer />
                                <v-col cols="auto" class="py-0 pl-0">
                                    <span class="font-weight-bold">
                                        <button
                                            class="primary--text"
                                            @click="
                                                filter.isDone = true;
                                                search();
                                            "
                                        >
                                            {{ dashboard.isDone }}
                                        </button>
                                    </span>
                                    건
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>

            <v-data-table v-model="selected" :headers="settlementsHeader" :items="settlements" :show-select="isConsole" disable-sort disable-pagination hide-default-footer class="elevation-1 mt-8">
                <template v-slot:item.createdAt="{ item }">
                    {{ item.createdAt.toDate() }}
                </template>
                <template v-slot:item.settlesAt="{ item }">
                    {{ item.settlesAt.toDate() }}
                </template>
                <template v-slot:item.totalAmount="{ item }"> {{ item.totalAmount.format() }} 원 </template>
                <template v-slot:item.companyName="{ item }">
                    {{ item.store.meta.companyName || item.store.name }}
                </template>
                <template v-slot:item.companyAccount="{ item }">
                    {{ item.store.bankname && item.store.bankAccount ? `${item.store.bankname} / ${item.store.bankAccount}` : "미기재" }}
                </template>
                <template v-slot:item.isDone="{ item }">
                    {{ item.isDone ? "정산완료" : "정산대기" }}
                </template>
                <template v-slot:item.actions="{ item }">
                    <v-icon @click="$router.push(`${$route.path}/${item._id}`)"> mdi-pencil </v-icon>
                </template>
            </v-data-table>
            <v-pagination v-model="page" :length="pageCount" :total-visible="11" class="mt-4 mb-12" @input="search"> </v-pagination>

            <v-card v-if="isConsole" class="mt-4">
                <v-card-text>
                    <v-row align="center">
                        <v-col cols="12" sm="3" md="2" class="py-0">정산처리</v-col>
                        <v-col cols="12" sm="9" md="10" class="py-0">
                            <v-btn color="primary" outlined class="mr-2" small @click="settlementComplete">정산 완료처리</v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-responsive>
    </v-layout>
</template>

<script>
import api from "@/api";
import VDateField from "@/components/plugins/vuetify/v-date-field.vue";
import { mdiCog } from "@mdi/js";
import OverlaySetting from "@/components/console/shop/settlements/overlay-setting.vue";

export default {
    components: {
        VDateField,
        OverlaySetting,
    },
    data() {
        return {
            mdiCog,
            ///////////////////////////////////////////////
            // 검색필터
            ///////////////////////////////////////////////
            showSearch: true,
            filter: {
                startDate: this.$route.query.startDate,
                endDate: this.$route.query.endDate,
                searchKey: this.$route.query.searchKey,
                searchValue: this.$route.query.searchValue,
                isDone: this.$route.query.isDone,
                createdAt: this.$route.query.createdAt,
            },
            searchKeys: [{ text: "전체", value: null }],

            ///////////////////////////////////////////////
            // 페이징
            ///////////////////////////////////////////////
            page: 1,
            pageCount: 0,
            limit: 20,

            ///////////////////////////////////////////////
            // 정산목록
            ///////////////////////////////////////////////
            selected: [],
            settlements: [],
            settlementsHeader: [
                {
                    text: "정산기준일",
                    value: "createdAt",
                    width: 110,
                },
                {
                    text: "정산예정일",
                    value: "settlesAt",
                    width: 110,
                },
                {
                    text: "정산금액(예상)",
                    value: "totalAmount",
                },
                {
                    text: "업체명",
                    value: "companyName",
                },
                {
                    text: "계좌번호",
                    value: "companyAccount",
                },
                {
                    text: "정산여부",
                    value: "isDone",
                    width: 120,
                },
                {
                    text: "actions",
                    value: "actions",
                    width: 80,
                },
            ],
            dashboard: {
                totalCount: 0,
                isDone: 0,
            },
        };
    },
    computed: {
        isConsole() {
            return this.$store.state.scope.includes("console");
        },
        _store() {
            return this.$store.state.payload._user;
        },
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            await this.search(false);
        },

        async search(routable = true) {
            const { isConsole, filter, _store } = this;
            try {
                if (routable) {
                    this.$router.push({
                        query: Object.assign({}, filter, { page: this.page }),
                    });
                }

                var { summary, settlements } = await api.console.shop.settlements.gets({
                    headers: {
                        skip: (this.page - 1) * this.limit,
                        limit: this.limit,
                    },
                    params: isConsole ? filter : { ...filter, _store },
                });

                this.settlements = settlements;
                this.pageCount = Math.ceil(summary.totalCount / this.limit);

                var { dashboard } = await api.console.shop.settlements.getDashboard(isConsole ? {} : { params: { _store } });
                this.dashboard = dashboard;
            } catch (error) {
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            }
        },

        // 수거완료
        async settlementComplete() {
            try {
                if (!this.selected.length) throw new Error("정산완료를 하기위한 구매건을 선택해주세요");
                for (var i in this.selected) {
                    await api.console.shop.settlements.put({
                        _id: this.selected[i]._id,
                        isDone: true,
                    });
                }

                alert("정산완료 처리되었습니다");
                this.search();
            } catch (error) {
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            }
        },
    },
};
</script>
